import { Checkbox, Flex, Image, Link, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { ButtonCmp } from '../../../components/ButtonCmp'

const urlPolitica = 'https://www.predictiveindex.com/privacy/privacy-respondent/'
const urlRedirecionamento = 'https://assessment.predictiveindex.com/bo/ay1/Prudential'

export const Prudential: React.FC = () => {
  const [Aceite, setAceite] = useState(false)

  return (
    <Flex minH='100vh' bg='white' direction='column' align='center' justify='center' px={4} py={8}>
      <Flex direction='column' align='center' gap={6} w='100%' maxW='36rem'>
        <Image
          src='https://sigah.blob.core.windows.net/assets/logoPI.svg'
          alt='Logo Predictive Index'
          w={{ base: '60%', md: '16rem' }}
          mb={12}
        />
        <Text textAlign='center' fontSize={{ base: 'sm', md: 'md' }} color='gray.700' mb={4}>
          Ao prosseguir com a pesquisa, você está ciente de que seus dados pessoais serão tratados conforme as diretrizes de tratamento da plataforma da Predictive Index.
        </Text>
        <Checkbox
          isChecked={Aceite}
          onChange={(e) => setAceite(e.target.checked)}
          alignItems='flex-start'
          size='lg'
          spacing='1.5rem'
          iconSize='1rem'
          sx={{ '.chakra-checkbox__control': { w: '28px', h: '28px' } }}
          mb={6}
        >
          <Text fontSize={{ base: 'sm', md: 'md' }} color='gray.700'>
            Estou ciente de que meus dados estão sendo tratados conforme a política{' '}
            <Link
              href={urlPolitica}
              isExternal
              color='blue.600'
              textDecoration='underline'
              onClick={(e) => e.stopPropagation()}
            >
              Services privacy - The Predictive Index
            </Link>.
          </Text>
        </Checkbox>
        <ButtonCmp
          VarColor='Rosa'
          big
          w={{ base: '100%', md: '12rem' }}
          isDisabled={!Aceite}
          onClick={() => window.location.assign(urlRedirecionamento)}
        >
          Prosseguir
        </ButtonCmp>
      </Flex>
    </Flex>
  )
}
